import type { R2BStagingBrandEntity } from "../../entity_types/r2bStagingBrand";

export const r2b_staging_vaughts: R2BStagingBrandEntity = {
  token: "r2b_staging_vaughts",
  type: "r2bStagingBrand",
  name: "Vaughts",
  avatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/81e61382f9157e0e28a8c44c69ac1859d7a16c4524e699b09c8a4d39c773bdf5.webp",
  productImageUrls: [
    "https://cdn.prerelease.faire.dev/fastly/81e61382f9157e0e28a8c44c69ac1859d7a16c4524e699b09c8a4d39c773bdf5.webp",
    "https://cdn.prerelease.faire.dev/fastly/6fe22033c0a43e1151fa29444e8b1f602112ed24e1a870f22e5ea1be018775c3.webp",
    "https://cdn.prerelease.faire.dev/fastly/8a01346a1e6c6704aad0ba0cffc6c7cb04388f5fb882fad736a5379218d21f1e.webp",
    "https://cdn.prerelease.faire.dev/fastly/609c7b136226be66209656e2a6f9abba1bf6ce8965f5baf509f9ba2d9f7446a9.jpeg",
    "https://cdn.prerelease.faire.dev/fastly/4b4955ab73d7063dcdd78f8262fa0fc2c512b0c4250c3578bb527ee41b0e4ca7.webp",
    "https://cdn.prerelease.faire.dev/fastly/43128be521c1b7639d3f9404deeb68c2460546c0bc51064bf9746d4f47abbcbe.webp",
    "https://cdn.prerelease.faire.dev/fastly/4aa8337171d9d3ec324284e579378ad76d6ddb6e24655db3031f2e985093ac30.webp",
    "https://cdn.prerelease.faire.dev/fastly/063dc0dc2c87f13b1502d284bdd1a8d8131f156cf92bb254353ad050e51690ec.webp",
    "https://cdn.prerelease.faire.dev/fastly/b628d05200164eeb28c0b30d8ede8ef8392888c60d90979a5c76ade6071fe93e.webp",
    "https://cdn.prerelease.faire.dev/fastly/7e00f2f68c55749568bcaf0ce818c167150272e5067249e89b7c84f18622c9b1.webp",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
